import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { authApi } from "../../api";
import { useAuth } from "../../../../app/providers/AuthProvider";
import { Button } from "../../../../shared/ui/button";
import { Input } from "../../../../shared/ui/input";
import zagrosLogo from "../../../../assets/images/zagros-logo.png";

const HERO_GRID_PATTERN =
  "url(\"data:image/svg+xml,%3Csvg width='160' height='160' viewBox='0 0 160 160' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' stroke='%23ffffff' stroke-opacity='.16' stroke-width='1'%3E%3Cpath d='M0 40h160M0 80h160M0 120h160M40 0v160M80 0v160M120 0v160'/%3E%3C/g%3E%3C/svg%3E\")";

const loginPageBackground =
  "radial-gradient(circle at 20% 20%, rgba(129, 140, 248, 0.22), transparent 28%), radial-gradient(circle at 80% 0%, rgba(20, 184, 166, 0.2), transparent 24%), linear-gradient(135deg, #eef2ff 0%, #f8fafc 45%, #ecfeff 100%)";

export default function Login() {
  const navigate = useNavigate();
  const { refetch } = useAuth();
  const [personnelCode, setPersonnelCode] = useState("");
  const [nationalCode, setNationalCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    const personnelCodeValue = personnelCode.trim();
    const nationalCodeValue = nationalCode.trim();

    if (!personnelCodeValue) return setError("لطفاً کد پرسنلی را وارد کنید.");
    if (!nationalCodeValue) return setError("لطفاً کد ملی را وارد کنید.");

    try {
      setLoading(true);
      await authApi.login({
        personnel_code: personnelCodeValue,
        national_code: nationalCodeValue || null,
      });
      await refetch();
      navigate("/");
    } catch (err) {
      console.error("Login failed:", err);
      setError(err.response?.data?.error || "خطا در ورود. شناسه را بررسی کنید.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="flex min-h-screen items-center justify-center p-8 rtl max-[760px]:p-4"
      style={{ background: loginPageBackground }}
    >
      <div className="grid min-h-[520px] w-full min-w-0 max-w-[920px] grid-cols-[minmax(280px,1fr)_390px] overflow-hidden rounded-[28px] border border-slate-400/20 bg-white/[0.82] shadow-[0_30px_70px_rgba(15,23,42,0.15)] backdrop-blur-[18px] max-[760px]:grid-cols-1">
        <div
          className="relative flex min-h-[240px] flex-col justify-between gap-6 p-12 text-white after:pointer-events-none after:absolute after:inset-6 after:rounded-3xl after:border after:border-white/15 after:content-[''] max-[760px]:p-8"
          style={{
            backgroundImage: `linear-gradient(145deg, rgba(49, 46, 129, 0.94), rgba(14, 116, 144, 0.88)), ${HERO_GRID_PATTERN}`,
          }}
        >
          <div className="relative z-[1] flex w-full items-start justify-center pt-2">
            <img
              src={zagrosLogo}
              alt="زاگرس هدف‌یار"
              className="block h-auto w-[min(280px,90%)] max-w-full object-contain max-[760px]:w-[min(220px,85%)]"
            />
          </div>
          <div className="relative z-[1] flex flex-col gap-4">
            <h1 className="max-w-[360px] text-center text-[2.3rem] font-black leading-[1.35] text-white">
              هدف‌یار
            </h1>
            <p className="max-w-[340px] leading-[1.9] text-blue-100">
              برای مشاهده عملکرد، تارگت‌ها و گزارش‌های تیم خود وارد شوید.
            </p>
          </div>
        </div>

        <form
          className="flex flex-col justify-center gap-3 bg-white/[0.96] p-11 rtl max-[760px]:p-[30px]"
          onSubmit={handleSubmit}
        >
          <div className="mb-4 flex items-center gap-3.5">
            <span
              className="inline-flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-[linear-gradient(135deg,#4f46e5,#0891b2)] text-[1.4rem] font-black text-white shadow-[0_12px_26px_rgba(79,70,229,0.28)]"
              aria-hidden="true"
            >
              ↗
            </span>
            <div>
              <h2 className="m-0 text-2xl font-black text-slate-900">ورود به حساب</h2>
              <p className="mt-1 text-sm text-slate-500">
                اطلاعات پرسنلی خود را وارد کنید.
              </p>
            </div>
          </div>

          {error && (
            <div className="rounded-card border border-red-200 bg-red-50 px-3.5 py-3 text-sm leading-[1.7] text-red-800">
              {error}
            </div>
          )}

          <label htmlFor="national-code" className="text-sm font-bold text-slate-700">
            کد ملی
          </label>
          <Input
            id="national-code"
            type="text"
            value={nationalCode}
            onChange={(e) => setNationalCode(e.target.value)}
            placeholder="25412521451"
            autoComplete="username"
            inputMode="numeric"
          />

          <label htmlFor="personnel-code" className="text-sm font-bold text-slate-700">
            کد پرسنلی
          </label>
          <Input
            id="personnel-code"
            type="password"
            value={personnelCode}
            onChange={(e) => setPersonnelCode(e.target.value)}
            placeholder="110217"
            autoComplete="current-password"
          />

          <Button type="submit" variant="loginSubmit" size="login" disabled={loading}>
            {loading ? "در حال ورود..." : "ورود"}
          </Button>
        </form>
      </div>
    </div>
  );
}
